import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { APP_CONFIG, AppConfiguration } from '@app/infrastructure/auth/app-configuration';
import { PartnerAliasEnum } from '@partners/partner-alias.enum';

@Component({
	selector: 'app-main-logo',
	templateUrl: './main-logo.component.html',
	styleUrls: ['./main-logo.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLogoComponent {
	@Input() imgHeight: number = 50;
	@Input() imgClasses: string = '';

	constructor(@Inject(APP_CONFIG) private appConfig: AppConfiguration) {}

	public get logoSrc(): string {
		return this.appConfig.partner.prefix === PartnerAliasEnum.Zesty
			? '/assets/images/logo/dark.png?v=4'
			: `/assets/images/logos/${this.appConfig.partner.prefix}/dark.png?v=4`;
	}
}
